import React from 'react';
import { Grid, TextField } from '@mui/material';
import FormDialog from '../../common/FormDialog';

const GradeBoundaryFormDialog = ({ open, onClose, onSubmit, editingBoundary, formData, setFormData, saving, isMobile = false }) => (
  <FormDialog open={open} onClose={onClose} onSubmit={onSubmit} title={editingBoundary ? 'Edit Grade Boundary' : 'Add Grade Boundary'} saving={saving} isMobile={isMobile}>
    <Grid container spacing={2} sx={{ pt: 1 }}>
      <Grid item xs={12} md={4}>
        <TextField fullWidth label="Grade" value={formData.grade} onChange={(e) => setFormData({ ...formData, grade: e.target.value })} inputProps={{ maxLength: 10 }} helperText="e.g. D1, C3, A, B+" required />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth type="number" label="Min %" value={formData.min_percentage} onChange={(e) => setFormData({ ...formData, min_percentage: e.target.value })} inputProps={{ min: 0, max: 100, step: 0.01 }} required />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth type="number" label="Max %" value={formData.max_percentage} onChange={(e) => setFormData({ ...formData, max_percentage: e.target.value })} inputProps={{ min: 0, max: 100, step: 0.01 }} required />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField fullWidth type="number" label="Grade Point (0–9.99)" value={formData.grade_point} onChange={(e) => setFormData({ ...formData, grade_point: e.target.value })} inputProps={{ min: 0, max: 9.99, step: 0.01 }} helperText="e.g. 4.00 for GPA systems" />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField fullWidth type="number" label="Aggregate Value (integer)" value={formData.aggregate_value} onChange={(e) => setFormData({ ...formData, aggregate_value: e.target.value })} inputProps={{ min: 0, step: 1 }} helperText="e.g. 1 for D1 in UCE/UACE" />
      </Grid>
      <Grid item xs={12}>
        <TextField fullWidth label="Description" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} placeholder="e.g., Distinction, Credit, Pass" />
      </Grid>
    </Grid>
  </FormDialog>
);

export default GradeBoundaryFormDialog;
